module.exports = __webpack_public_path__ + "static/media/mobile-step4-en.555eca27.png";